import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import DashboardLayout from "../../../components/layout/DashboardLayout";
import fiscalDeviceService from "../../../apis/services/admin/fiscalDeviceService";
import styles from "./LpfrIncidentsScreen.module.scss";

const TABS = [
  { value: "open", label: "Aktivni" },
  { value: "resolved", label: "Rešeni" },
];

const LpfrIncidentsScreen = () => {
  const [state, setState] = useState("open");
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async (nextState) => {
    setLoading(true);
    try {
      const { data } = await fiscalDeviceService.fetchLpfrIncidents(nextState);
      setIncidents(data?.incidents || []);
    } catch (err) {
      setIncidents([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load(state);
  }, [state, load]);

  return (
    <DashboardLayout>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.title}>LPFR-ovi u kvaru</p>
          <div className={styles.tabs}>
            {TABS.map((tab) => (
              <div
                key={tab.value}
                className={state === tab.value ? styles.tabActive : styles.tab}
                onClick={() => setState(tab.value)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.table}>
          <div className={styles.tableHeader}>
            <div className={styles.cell}>Uređaj</div>
            <div className={styles.cell}>Firma</div>
            <div className={styles.cell}>Poslovna jedinica</div>
            <div className={styles.cell}>Razlog</div>
            <div className={styles.cell}>Trajanje</div>
            <div className={styles.cell}>Failover</div>
          </div>

          {!loading && incidents.length === 0 && (
            <div className={styles.emptyState}>
              {state === "open"
                ? "Nema aktivnih LPFR problema."
                : "Nema rešenih LPFR problema."}
            </div>
          )}

          {incidents.map((incident) => (
            <div className={styles.row} key={incident.id}>
              <div className={styles.cell}>
                <Link
                  to={`/fiscal-devices/${incident.fiscalDeviceId}`}
                  className={styles.deviceLink}
                >
                  {incident.deviceName || incident.fiscalDeviceId}
                </Link>
              </div>
              <div className={styles.cell}>
                {incident.companyName
                  ? `${incident.companyName} (PIB ${incident.companyPIB || "-"})`
                  : "-"}
              </div>
              <div className={styles.cell}>{incident.businessUnitName || "-"}</div>
              <div className={styles.cell}>
                <span className={styles.reasonBadge}>{incident.reasonText || incident.reasonCode}</span>
              </div>
              <div className={styles.cell}>{incident.duration}</div>
              <div className={styles.cell}>
                <span
                  className={classNames(
                    incident.failoverActive
                      ? styles.failoverActive
                      : styles.failoverInactive
                  )}
                >
                  {incident.failoverActive
                    ? "Aktivan"
                    : incident.vpfrAvailable
                    ? "Moguć"
                    : "Nedostupan"}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LpfrIncidentsScreen;
